module.exports = __webpack_public_path__ + "static/fonts/DINPro-Regular.86fda987.ttf";